import { UnknownString } from '../constants';
import { round } from './number';

export const formatCc = (val) => {
  if (val === false || val === undefined) return UnknownString;
  if (val >= 0 && val <= 95) {
    return `${round(val, 0)}%`;
  }

  return UnknownString;
};

export default {
  formatCc,
};
